// arbeitsergebnisse_tabelle — the REF | ARBEITSERGEBNIS | ABNAHMEKRITERIEN (KURZFORM) | TERMIN
// table (v15 slides 7/8). Row placement (y/height) comes from the bound resolver's
// paginateTabelle run — the preview places rows exactly where the PPTX template will.
// One deck slide can span several rendered pages; `page` picks which one to draw.
//
// The column headers are frozen document text (German, golden master), not UI strings.
import type { ArbeitsergebnisseTabelleContent, TabelleBound } from '../../../../shared/deckTypes.js';
import { Abs, Brand, Dkp, Eyebrow, PageNo, Rule, fmtDot } from './chrome.js';

export default function ArbeitsergebnisseTabellePreview({ content, bound, page = 0, pageNo }: {
  content: ArbeitsergebnisseTabelleContent;
  bound?: TabelleBound;
  page?: number;
  pageNo?: number | null;
}) {
  const c = content;
  const pages = bound?.pages ?? [];
  const rows = pages[page] ?? [];
  const eyebrow = c.eyebrow
    ? pages.length > 1 ? `${c.eyebrow} · ${page + 1}/${pages.length}` : c.eyebrow
    : '';

  return (
    <Dkp>
      <Eyebrow text={eyebrow} />
      <Abs x={64} y={84} w={1000}>
        <div className="dkp-title" style={{ fontSize: 29.3 }}>{c.title}</div>
      </Abs>

      {/* table head (frozen) */}
      <Abs x={64} y={158}><span className="dkp-th">REF</span></Abs>
      <Abs x={140} y={158}><span className="dkp-th">ARBEITSERGEBNIS</span></Abs>
      <Abs x={452} y={158}><span className="dkp-th">ABNAHMEKRITERIEN (KURZFORM)</span></Abs>
      <Abs x={1104} y={158}><span className="dkp-th">TERMIN</span></Abs>
      <Rule x={64} y={174} w={1152} color="#121316" />

      {rows.map((r) => (
        <div key={r.ref}>
          <Abs x={64} y={r.y + 2} w={70}>
            <span className="dkp-mono" style={{ fontSize: 9.3, fontWeight: 700, color: '#8A6F3E' }}>{r.ref}</span>
          </Abs>
          <Abs x={140} y={r.y} w={296}>
            <div className="dkp-serif" style={{ fontSize: 13.3, lineHeight: 1.28 }}>{r.name}</div>
            {r.subtitle ? (
              <div style={{ fontSize: 11, color: '#63666D', lineHeight: 1.32, marginTop: 1 }}>{r.subtitle}</div>
            ) : null}
          </Abs>
          <Abs x={452} y={r.y + 2} w={624}>
            <div style={{ fontSize: 12, fontWeight: 500, color: '#3A3D42', lineHeight: '19.5px' }}>{r.kurzform}</div>
          </Abs>
          <Abs x={1104} y={r.y + 2} w={112}>
            <span className="dkp-mono" style={{ fontSize: 10.7, color: '#3A3D42' }}>{fmtDot(r.due)}</span>
          </Abs>
        </div>
      ))}

      {c.footer_note ? (
        <>
          <Rule x={64} y={648} w={1152} />
          <Abs x={64} y={660} w={1152}>
            <div className="dkp-footline">{c.footer_note}</div>
          </Abs>
        </>
      ) : null}

      <Brand />
      <PageNo n={pageNo} />
    </Dkp>
  );
}
